module.exports = __webpack_public_path__ + "img/06.2af54659.png";